export default __webpack_public_path__ + "static/media/portfolio-19.b6cf82b5.jpg";